export default function onDOMReady(callback) {
  // Check if DOMContentLoaded has already fired
  if (document.readyState !== "loading") {
    // DOM is ready; run callback immediately
    callback();
  } else {
    // DOM is still loading; wait for the event
    document.addEventListener("DOMContentLoaded", callback);
  }
}
